import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import { isRtl } from 'src/helper/tool'


export default class extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { lang, nav, language, now } = this.props
    return (
      <div className={`nav2 navbg${nav} ${isRtl(language) && 'arlang'}`}>
        <div className={`navitem ${nav == 0 && "active"}`} onClick={this.props.changeNav2.bind(this, 0)}>{lang.world}</div>
        <div className={`navitem ${nav == 1 && "active"}`} onClick={this.props.changeNav2.bind(this, 1)}>{lang.country}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly/Nav2/index.js